module.exports = __webpack_public_path__ + "img/stock5.5d73a045.png";